import { render } from "./ModalSetting.vue?vue&type=template&id=13cdc546&scoped=true"
import script from "./ModalSetting.vue?vue&type=script&lang=js"
export * from "./ModalSetting.vue?vue&type=script&lang=js"

import "./ModalSetting.vue?vue&type=style&index=0&id=13cdc546&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-13cdc546"

export default script